import { useLanguage } from '../contexts/LanguageContext';
import ptTranslations from '../translations/pt.json';
import enTranslations from '../translations/en.json';

const translations = {
  pt: ptTranslations,
  en: enTranslations
};

export const useTranslation = () => {
  const { language } = useLanguage();
  
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        // Fallback para português se a tradução não existir
        value = translations.pt;
        for (const k2 of keys) {
          if (value && value[k2]) {
            value = value[k2];
          } else {
            return key; // Retorna a chave se não encontrar tradução
          }
        }
        break;
      }
    }
    
    return value || key;
  };
  
  return { t, language };
};






